var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCredits = function SvgCredits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M15.112 1.602a1.8 1.8 0 0 0-2.61.368L8.852 7.2h1.464l3.168-4.542a.6.6 0 0 1 .87-.123l.97.788-2.68 3.877h1.459l2.155-3.12 2.02 1.64a.6.6 0 0 1 .114.81l-.468.67h1.464a1.8 1.8 0 0 0-.353-2.412zM5.9 6a1.8 1.8 0 0 0-1.8 1.8v9.6a3 3 0 0 0 3 3h11.4a2.4 2.4 0 0 0 2.4-2.4v-7.2a2.4 2.4 0 0 0-2.4-2.4H5.9a.6.6 0 1 1 0-1.2h1.762l.84-1.2zm10.8 8.4h1.2a.6.6 0 0 1 0 1.2h-1.2a.6.6 0 0 1 0-1.2"
  })));
};
export default SvgCredits;